import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class SymphonyAuthService {
  public readonly jwtValidated$ = new Subject<any>();
  
  private readonly backendUri = `${environment.QMAAPI_URL}/QMA2/bdk/v1/app`;
  private readonly appId = `${environment.SYMPHONY_APP_ID}`;
  private readonly headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  getConfig(): any {
    return {
      id: this.appId,
      circleOfTrust: {
        getAppToken: () => this.getAppToken(),
        validateAppToken: (appToken: string, symphonyToken: string) => this.validateAppToken(appToken, symphonyToken),
        validateJwt: (jwt: string) => this.validateJwt(jwt),
      },
    };
  }

  getAppToken(): Promise<string> {
    return fetch(`${this.backendUri}/auth`, { method: 'POST' })
      .then(r => r.json())
      .then(r => r.appToken);
  }

  validateAppToken(appToken: string, symphonyToken: string): Promise<void> {
    return fetch(`${this.backendUri}/tokens`, {
      method: 'POST',
      body: JSON.stringify({ appToken, symphonyToken }),
      headers: this.headers,
    }).then(() => undefined);
  }

  validateJwt(jwt: string): Promise<any> {
    sessionStorage.setItem('symphony_jwt', jwt);
    return fetch(`${this.backendUri}/jwt`, {
      method: 'POST',
      body: JSON.stringify({ jwt }),
      headers: this.headers,
    })
      .then(r => r.json())
      .then(payload => {
        this.jwtValidated$.next(payload);
        return payload;
      });
  }
}
